import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../../core/services/app-config.service';

@Component({
  selector: 'app-footer',
  template: require('./footer.component.html'),
  styles: [require('./footer.component.sass')]
})
export class FooterComponent implements OnInit {

  @Input() isAdmin: boolean;

  appVersion$: Observable<string>;

  today = new Date();

  constructor(
    private appConfigService: AppConfigService
  ) { 
    this.appVersion$ = this.appConfigService.getNMSversion()
  }

  ngOnInit(): void {
  }
}
